import Link from 'next/link'
import React from 'react'
import { useAppContext } from '../../../context/siteMapContext'
import { IArticleHead } from '../../../interfaces/article'
import { MediaTypeEnum } from '../../../interfaces/media'
import { urlObjectFactoryForPagesWithSlug } from '../../../utils/webmenus'
import ImageItem from '../../article/imageItem.component'
import VideoItem from '../../article/videoItem.component'
import ReadButton from '../../articleList/readBtn.component'
import WaterMark from '../../waterMark.component'

interface ICampaignProps {
  campaign: IArticleHead
}

const CampaignPanel: React.FC<ICampaignProps> = ({ campaign }) => {
  const { title, coverImage, lead } = campaign
  const { webmenus, highContrastOn } = useAppContext()
  const webmenu = webmenus[campaign.heading]
  const { urlObject, asPath } = urlObjectFactoryForPagesWithSlug(
    '/article',
    campaign,
    webmenu
  )

  return (
    <section className={`relative mx-page-side-negative-margin py-[24px] mb-[44px] 2xl:mb-0 px-[22px] 2xl:py-[60px] 2xl:gap-5.5 bg-footer-background ${highContrastOn ? 'bg-[#333] mb-0' : ''}`}>
      <div className='w-full h-full 2xl:grid grid-cols-4 2xl:grid-cols-12'>
        {!highContrastOn && <div className='hidden 2xl:block h-[calc(100%+120px)] my-[-60px] ml-[-22px] w-[calc(100%-56px)] bg-cover bg-center 2xl:col-start-1 col-span-2 bg-[url("../public/body/Special_two_blocks.svg")]'></div>}
        <div className='col-start-1 2xl:col-start-3 col-span-4 2xl:col-span-2 2xl:pr-[26px] 2xl:ml-[-64px]'>
          <h2 className='text-home-campaign-title font-jost font-medium text-white text-[1.8rem] pb-[20px]'>
            {title}
          </h2>
        </div>
        <Link href={urlObject} as={asPath} shallow>
          <a className='col-start-1 2xl:col-start-5 col-span-4 2xl:col-span-4 2xl:font-bold'>
            <div >
              <div
                dangerouslySetInnerHTML={{ __html: lead }}
                className='text-home-campaign text-white pb-8 2xl:text-[2.4rem] 2xl:leading-[3.2rem] font-Montserrat-Regular'
              />
              <div className='h-[calc(100vw/16*9)] 2xl:h-[320px] overflow-hidden'>
                {coverImage?.type === MediaTypeEnum.VIDEO ? (
                  <VideoItem
                    url={coverImage?.fileThumbUrl}
                    title={coverImage?.title}
                  />
                ) : (
                  <ImageItem
                    url={coverImage?.fileThumbUrl}
                    title={coverImage?.title}
                  />
                )}
              </div>
            </div>
          </a>
        </Link>
        <div className='grid-col-0 mr-[-22px]'>
          <WaterMark transparent={true} isLarge={false} />
        </div>
      </div>

      <div className={`2xl:hidden absolute bottom-[-48px] w-full left-0 ${highContrastOn ? 'hidden' : 'block'}`}>
        <div className='w-full h-[24px] bg-[url("../public/body/Mobil_medium_blue.svg")] bg-cover'></div>
        <div className='w-full h-[24px] bg-[url("../public/body/Mobil_light_blue.svg")] bg-cover'></div>
      </div>
    </section>
  )
}

export default CampaignPanel
